import Layout from '../../../../../layout/Layout'
import { useParams } from 'react-router-dom'
import PatternEdit from 'templates/presentation/components/organisms/PatternEdit/PatternEdit'

export default function EditTemplatePage() {
    const { patternId } = useParams()
    const patternIdNumber = Number(patternId)

    return (
        <Layout>
            <PatternEdit patternId={patternIdNumber} />
        </Layout>
    )
}
